import { ActionReducer, Action } from '@ngrx/store';

export const RESET_PRICE = 'RESET_PRICE';
export const UPDATE_PRICE_OBJECT = 'UPDATE_PRICE_OBJECT';
export const UPDATE_PRICE_STATUS = 'UPDATE_PRICE_STATUS';
export const AMEND_PAYMENT_CONFIRMED = 'AMEND_PAYMENT_CONFIRMED';
export const REFRESH_PRICE_OBJECT = 'REFRESH_PRICE_OBJECT';
export const UPDATE_SBB_SUBSIDY_AMOUNT = 'UPDATE_SBB_SUBSIDY_AMOUNT';
export const UPDATE_SBB_DB_SUBSIDY_AMOUNT = 'UPDATE_SBB_DB_SUBSIDY_AMOUNT';
export const UPDATE_CAT_DISCOUNT_AMOUNT = 'UPDATE_CAT_DISCOUNT_AMOUNT';
export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

const initState = {
  price: {},
  sbbSubsidyAmount: 0,
  dbSubsidyAmount: 0,
  CatDiscountAmount: 0,
  amendPaymentConfirmed: false,
  priceCount: 0,
  priceLoading: false
};

export function priceReducer(state: any = initState, action: ActionWithPayloadInterface) {

  switch (action.type) {

    case UPDATE_PRICE_OBJECT:
      return updatePrice(state, action.payload);

    case REFRESH_PRICE_OBJECT:
      return Object.assign({}, state, { priceCount: state.priceCount + 1 });

    case UPDATE_PRICE_STATUS:
      return Object.assign({}, state, { priceLoading: action.payload });

    case RESET_PRICE:
      return resetPrice(state, action.payload);

    case AMEND_PAYMENT_CONFIRMED:
      return Object.assign({}, state, { amendPaymentConfirmed: action.payload });

    case UPDATE_SBB_SUBSIDY_AMOUNT:
      return Object.assign({}, state, { sbbSubsidyAmount: action.payload });

    case UPDATE_SBB_DB_SUBSIDY_AMOUNT:
      return Object.assign({}, state, { dbSubsidyAmount: action.payload });

    case UPDATE_CAT_DISCOUNT_AMOUNT:
      return Object.assign({}, state, { CatDiscountAmount: action.payload });

    default:
      return state;
  }

};

export function resetPrice(state: any, priceObj: any) {
  return {
    price: initState.price,
    sbbSubsidyAmount: 0,
    dbSubsidyAmount: 0,
    CatDiscountAmount: 0,
    amendPaymentConfirmed: false,
    priceCount: 0,
    priceLoading: false
  };
}
export function updatePrice(state: any, priceObj: any) {
  return {
    price: priceObj,
    amendPaymentConfirmed: state.amendPaymentConfirmed,
    priceCount: 0,
    priceLoading: false
  };
}
